import { AuthActions, SIGNUP, LOGIN, LOGOUT, REAUTHENTICATE, SIGNUP_FACEBOOK } from './auth-types';

import { authService } from '@dev.boon/brent';
import { userService } from '@services/user/user-service';

import UserInterface from './user.interface';
import UserFbInterface from './user-fb.interface';
import { gaLogin, gaSignup } from '@root/src/services/google/gtag';

export const signup = (user: UserInterface) => async (dispatch: (param: AuthActions) => void) => {
    try {
        const result = await userService.signupUser(user);
        result.user.role = result.user.role.split(',');

        dispatch({
            type: SIGNUP,
            payload: {
                token: result.accessToken,
                refreshToken: result.refreshToken,
                user: result.user,
            },
        });
        gaSignup('local');
    } catch (error) {
        throw error;
    }
};

export const signupFacebook = (userFb: UserFbInterface) => async (dispatch: (param: AuthActions) => void) => {
    try {
        const result = await authService.signupUserFb(userFb);

        dispatch({
            type: SIGNUP_FACEBOOK,
            payload: {
                token: result.accessToken,
                refreshToken: result.refreshToken,
                user: result.user,
            },
        });
        gaLogin('facebook');
    } catch (error) {
        throw error;
    }
};

export const login = (email: string, password: string) => async (dispatch: (param: AuthActions) => void) => {
    try {
        const result = await authService.loginUser(email, password);

        dispatch({
            type: LOGIN,
            payload: {
                token: result.accessToken,
                refreshToken: result.refreshToken,
                user: result.user,
            },
        });
        gaLogin('local');
    } catch (error) {
        throw error;
    }
};

export const logout = () => (dispatch: (param: AuthActions) => void) => {
    try {
        authService.logoutUser();

        dispatch({
            type: LOGOUT,
        });
    } catch (error) {
        throw error;
    }
};

export const reauthenticate = (accessToken, refreshToken) => async (dispatch: (param: AuthActions) => void) => {
    try {
        const result = await authService.reauthUser(accessToken, refreshToken);

        dispatch({
            type: REAUTHENTICATE,
            payload: {
                token: result.accessToken,
                user: result.user,
            },
        });
    } catch (error) {
        // do nothing
    }
};
